module.exports = __webpack_public_path__ + "img/motion.ca44b466.gif";